import axios from 'axios';
import { useLocalStorage } from '@vueuse/core';

const token = useLocalStorage('token', '');

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL + 'api/',
});

instance.interceptors.request.use(
  (config) => {
    if (token.value) {
      config.headers.Authorization = `Bearer ${token.value}`;
    }
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      token.value = '';
      setTimeout(() => {
        window.location.href = '/';
      }, 1000);
    }
    return Promise.reject(error);
  }
);

export default instance;
